import React from "react"
import PropTypes from "prop-types"

const FiltrosFecha = ({ fechaDesde, fechaHasta, onChange, onAplicar, onLimpiar, loading }) => {
  const ambasLlenas = Boolean(fechaDesde && fechaHasta)
  const rangoValido = !fechaDesde || !fechaHasta || fechaDesde <= fechaHasta
  const puedeAplicar = ambasLlenas && rangoValido && !loading

  const labelStyle = { color: "#334155" }

  return (
    <div className="d-flex flex-wrap align-items-end gap-2">
      <div>
        <label className="form-label fw-semibold small mb-1" style={labelStyle}>
          Desde <span style={{ color: "#dc2626" }}>*</span>
        </label>
        <input
          type="date"
          className="form-control form-control-sm"
          value={fechaDesde}
          onChange={e => onChange({ fechaDesde: e.target.value, fechaHasta })}
          max={fechaHasta || undefined}
          required
          style={{
            minWidth: 150,
            borderColor: fechaDesde ? "#cbd5e1" : "#fca5a5",
          }}
        />
      </div>
      <div>
        <label className="form-label fw-semibold small mb-1" style={labelStyle}>
          Hasta <span style={{ color: "#dc2626" }}>*</span>
        </label>
        <input
          type="date"
          className="form-control form-control-sm"
          value={fechaHasta}
          onChange={e => onChange({ fechaDesde, fechaHasta: e.target.value })}
          min={fechaDesde || undefined}
          required
          style={{
            minWidth: 150,
            borderColor: fechaHasta ? "#cbd5e1" : "#fca5a5",
          }}
        />
      </div>
      <button
        type="button"
        className="btn btn-sm btn-primary"
        onClick={onAplicar}
        disabled={!puedeAplicar}
        title={
          !ambasLlenas
            ? "Las dos fechas son obligatorias"
            : !rangoValido
              ? "La fecha 'Desde' debe ser anterior a 'Hasta'"
              : ""
        }
      >
        <i className="mdi mdi-magnify me-1" />
        Consultar
      </button>
      {(fechaDesde || fechaHasta) && (
        <button
          type="button"
          className="btn btn-sm btn-outline-secondary"
          onClick={onLimpiar}
          disabled={loading}
          title="Limpiar fechas"
        >
          <i className="mdi mdi-close" />
        </button>
      )}
    </div>
  )
}

FiltrosFecha.propTypes = {
  fechaDesde: PropTypes.string.isRequired,
  fechaHasta: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onAplicar: PropTypes.func.isRequired,
  onLimpiar: PropTypes.func.isRequired,
  loading: PropTypes.bool,
}

export default FiltrosFecha
